import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-license-rejected-list',
  templateUrl: './license-rejected-list.component.html',
  styleUrls: ['./license-rejected-list.component.css']
})
export class LicenseRejectedListComponent implements OnInit {
  title="PSA Licence Rejected List";
  toDay ;
  constructor() {    
    this.toDay = new Date();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/view/rpt-form/report-list/license-rejected-list/license-rejected-list.component.ts